import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LibraryApiCall from 'LibraryApiCall';
import config from 'config';
import { toast } from 'react-toastify';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import Select from 'react-select';
import Barcode from "react-barcode";
import ReactToPrint from "react-to-print";
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

class AddResourceCopies extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES TO GET RESOURCE DETAILS
            resourceResponseData: {},
            loadingResourceData: false,
            resourceData: {},

            selectedRows: [],

            isAddingAccessionSeries: false,
            isUpdateAccessionSeries: false,
            accessionSeriesText: '',
            accessionNumberText: '',
            isDeleteAccessionSeries: false,
            selectedRow: '',
            currentAccessionSeriesNo: null,
            loadingDeletingData: false,
            deleteType: '',
            isAddResourceCopies: false,

            //STATE FOR ACTION
            itemVisibilityForRows: [
                { name: "Delete", key: 'delete', icon: ["fa", "trash"] },
                { name: 'Print Barcode 2 Copies', key: 'printTwoBarcode', icon: ["fa", "print"] },
                { name: 'Print Barcode 3 Copies', key: 'printThreeBarcode', icon: ["fa", "print"] },
                { name: "Print Barcode 4 Copies", key: 'printFourBarcode', icon: ["fa", "print"] }
            ],

            copiesAccessionSeries: '',
            copiesAccessionNumber: '',
            copiesNoOfCopies: 1,

            // field validation
            accessionSeriesWarning: '',
            accessionNumberWarning: '',
            accessError: '',

            printBarcodeModal: false,
            printBarcodeType: '',

            showActivitySlider: false,
            selectedIid:"",
            hoverID:"",
        }
    }

    componentDidMount() {
        this.GetLibraryResourceDetails()
    }

    // basic resource list
    GetLibraryResourceDetails = async () => {
        this.setState({
            loadingResourceData: true
        });

        let requestData = {
            iid: this.props.ResourceData.resourceIID, // config.institute_id,
            uniqueid: this.props.ResourceData.uniqueId
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "GetLibraryResourceDetails",
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let filteredResponseData = Object.entries(apiResult)
                    .filter(([key, value]) => key == this.props.ResourceData.uniqueId)
                    .map(([key, value]) => ({ id: key, ...value }));

                this.setState({
                    resourceResponseData: apiResult,
                    resourceData: filteredResponseData,
                    loadingResourceData: false
                });
            }
        }
    };

    closeResourceCopiesModal = () => {
        this.props.onClose(); // Call parent function directly
    }

    // single checkbox check 
    handleCheckboxChange = (id) => {
        this.setState((prevState) => {
            const selectedRows = prevState.selectedRows.includes(id)
                ? prevState.selectedRows.filter((rowId) => rowId !== id) // Remove if already selected
                : [...prevState.selectedRows, id]; // Add if not selected

            let updatedSelectedRows = prevState.selectedRows.includes(id)
                ? prevState.selectedRows.filter(rowId => rowId !== id) // Deselect
                : [...prevState.selectedRows, id]; // Select

            // Get the selected row objects
            const allResources = Object.values(prevState.resourceResponseData);
            const selectedRowObjects = allResources.filter(row =>
                updatedSelectedRows.includes(row.uniqueId)
            );

            // Determine final selectedRow (single or array)
            let selectedRow = null;
            if (selectedRowObjects.length === 1) {
                selectedRow = selectedRowObjects[0];
            } else if (selectedRowObjects.length > 1) {
                selectedRow = selectedRowObjects;
            }

            return { selectedRows, selectedRow: selectedRow };
        });

    };

    // multiple checkbox check 
    handleSelectAllCheckboxChange = () => {
        this.setState((prevState) => {
            const allRowsSelected = prevState.selectedRows.length === Object.values(this.state.resourceResponseData).length;

            return {
                selectedRows: allRowsSelected ? [] : Object.values(this.state.resourceResponseData).map((project) => project.uniqueId),
                selectedRow: Object.values(this.state.resourceResponseData)
            };
        });
    };

    UpdateLibraryResourceCopies = async () => {
        let requestData = {
            'iid': this.props.ResourceData.resourceIID, // config.institute_id,
            'accessionnumber': this.state.accessionNumberText,
            'facultyId': config.faculty_id,
            'uniqueId': this.state.selectedRow.uniqueId,
            'resourceid': this.props.ResourceData.uniqueId,
            'seriesid': this.state.accessionSeriesText?.length > 0 ? this.state.accessionSeriesText[0].value : this.state.accessionSeriesText.value
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'UpdateLibraryResourceCopies',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.UpdateLibraryResourceCopies();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult.status == "success") {
                    this.setState({ isAddingAccessionSeries: false, accessionSeriesText: '', isUpdateAccessionSeries: false, currentAccessionSeriesNo: null })
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.GetLibraryResourceDetails()
                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while updating resources data. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    DeleteLibraryResourceCopy = async () => {
        this.setState({ loadingDeletingData: true })

        let requestData = {
            'iid': this.props.ResourceData.resourceIID, // config.institute_id,
            'unique_id': this.state.deleteType === "deleteRow" ? [this.state.selectedRow.uniqueId] : this.state.selectedRows,
            'facultyId': config.faculty_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'DeleteLibraryResourceCopy',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.DeleteLibraryResourceCopy();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({ isDeleteAccessionSeries: false, selectedRow: '', selectedRows: '', loadingDeletingData: false })
                let apiResult = jsonResponse.APIResult;
                if (apiResult.status == "success") {
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.GetLibraryResourceDetails()
                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                this.setState({ isDeleteAccessionSeries: false, selectedRow: '', selectedRows: '', loadingDeletingData: false })
                toast.error('Something went wrong while updating resources data. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    deleteAccessionSeriesData = () => {
        return (
            <div className={this.state.isDeleteAccessionSeries ? "modal fade show" : "modal fade"} id="modalContainer">
                <div class="modal-dialog modal-dialog-centered">
                    <div className="modal-content modalBulkContent">
                        {/* Modal Header */}
                        <div className="modal-header" style={{ padding: '20px 25px', backgroundColor: '#c34141', color: ' #ffffff' }}>
                            <h6 className="modal-title">
                                <FontAwesomeIcon size='sm' icon={["fa", "exclamation-triangle"]} style={{ marginRight: '10px' }} />
                                Are you sure?
                            </h6>
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => { this.setState({ isDeleteAccessionSeries: false }) }} style={{ cursor: "pointer" }} />
                        </div>

                        <div className="custom-form-body" style={{ padding: '20px 25px' }}>
                            <strong>NOTE:</strong>
                            <ul>
                                <li>All data associated with resource copy will be deleted.</li>
                                <li>
                                    You can again add new resource copy by clicking on {" "}
                                    <span className="Link" style={{ color: "blue", textDecoration: "underline" }}>
                                        Add Copies
                                    </span>
                                </li>
                            </ul>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer" style={{ padding: '20px 25px' }}>
                            <button
                                className="btn delete-primary-button"
                                style={{ fontSize: '14px', borderRadius: '7px' }}
                                onClick={() => { this.setState({ isDeleteAccessionSeries: false }) }}
                            >
                                No
                            </button>
                            <button className="btn delete-outline-button waves-effect" style={{ fontSize: '14px', borderRadius: '7px' }}
                                onClick={() => { this.DeleteLibraryResourceCopy() }} disabled={this.state.loadingDeletingData}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    actionButtonOnChange = (action) => {
        if (action === 'Delete') {
            this.setState({ isDeleteAccessionSeries: true, deleteType: '' })
        } else (
            this.setState({ printBarcodeModal: true, printBarcodeType: action })
        )
    }

    // This function is used to accession number increment
    incrementLeadingZeroNumber = (leadingZeroString, amountToIncrement) => {
        var amountOfZerosToAdd = leadingZeroString.length;
        var stringToNumber = (+leadingZeroString);
        var zerosToAdd = new Array(amountOfZerosToAdd + 1).join('0');

        var zerosAndNewNumber = zerosToAdd + (stringToNumber + amountToIncrement)
        var amountToSlice = (-1 * amountOfZerosToAdd)
        var newString = zerosAndNewNumber.slice(amountToSlice)
        return newString
    }

    incrementAlphanumericAccessionNumber = (str) => {
        str = str.toString();
        const numPart = str.match(/([0-9])+$|([0-9]+)$/)[0];
        const strPart = str.slice(0, str.indexOf(numPart));
        const isLastIndexNine = numPart.match(/9$/);

        let incrementedNumber = '';
        // If we have a leading zero (e.g. - 'L100A099') 
        // or there is no prefix - we should just increment the number
        if (isLastIndexNine || strPart != null) {
            incrementedNumber = strPart + numPart.replace(/\d+$/, (n) => this.incrementLeadingZeroNumber(n, 1));
        }
        // Increment the number and add the missing zero
        else {
            incrementedNumber = strPart + '0' + numPart.replace(/\d+$/, (n) => ++n);
        }
        return incrementedNumber;
    }

    GetMaximumLibraryAccession = async (from) => {
        this.setState({
            loadingGetMaximumLibraryAccession: true,
        })
        let requestData = {
            iid: this.props.ResourceData.resourceIID, // config.institute_id,
            accesseriesid: this.state.copiesAccessionSeries.uniqueId
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetMaximumLibraryAccession',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetMaximumLibraryAccession();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetMaximumLibraryAccessionValue: apiResult.data,
                    loadingGetMaximumLibraryAccession: false,
                })
                if (this.state.GetMaximumLibraryAccessionValue == null) {
                    this.state.GetMaximumLibraryAccessionValue = 1;
                }
                else {
                    // this function is used to accession number increment
                    this.state.GetMaximumLibraryAccessionValue = this.incrementAlphanumericAccessionNumber(this.state.GetMaximumLibraryAccessionValue);
                }

                this.setState({ copiesAccessionNumber: this.state.GetMaximumLibraryAccessionValue, copiesNoOfCopies: 1, accessError: "Accession number from " + this.state.GetMaximumLibraryAccessionValue + " to " + this.state.GetMaximumLibraryAccessionValue })

            } else {
                this.setState({
                    loadingGetMaximumLibraryAccession: false,
                })
            }
        }
    }

    //function to check accession number 00
    checkAccessionNumber = async (source, from) => {
        let Accessseriesid = "";

        Accessseriesid = this.state.copiesAccessionSeries.uniqueId

        if (source) {
            if (this.state.copiesAccessionSeries != "") {
                //create an array containing accession numbers
                let accessionNo = ""
                accessionNo = this.state.copiesAccessionNumber;

                if (accessionNo != "") {

                    //check if accession no positive integer
                    if (accessionNo != 0) {
                        const numPart = accessionNo.match(/([0-9])+$|([0-9]+)$/)[0];
                        const strPart = accessionNo.slice(0, accessionNo.indexOf(numPart));
                        const isLastIndexNine = numPart.match(/9$/);


                        let AccessionNumberArray = [];
                        //codeto get no of copies            
                        let noofcopies = this.state.copiesNoOfCopies;

                        // If Accession Number MM00001
                        if (isLastIndexNine || strPart != null) {

                            accessionNo = parseInt(numPart);
                            if (noofcopies != "" && noofcopies != '0') {
                                for (let i = 0; i < parseInt(noofcopies); i++) {
                                    let temp = "";
                                    temp = strPart + "" + accessionNo;
                                    AccessionNumberArray.push(temp);
                                    accessionNo++
                                }
                            }
                            else {
                                AccessionNumberArray = [accessionNo];
                            }
                        }
                        else // accession number 1
                        {
                            accessionNo = parseInt(accessionNo);
                            if (noofcopies != "" && noofcopies != '0') {
                                for (let i = 0; i < parseInt(noofcopies); i++) {

                                    AccessionNumberArray.push(accessionNo);
                                    accessionNo++;
                                }
                            }
                            else {
                                AccessionNumberArray = [accessionNo];
                            }
                        }
                        //code to create accession series id array
                        let accessionsertiesidArray = [Accessseriesid];

                        let extraParam = {
                            source: source,
                            from: from,
                            AccessionNumberArray: AccessionNumberArray
                        }

                        let requestData = {
                            iid: this.props.ResourceData.resourceIID, // config.institute_id,
                            accessionNoArray: AccessionNumberArray,
                            seriesIdArray: accessionsertiesidArray
                        };

                        let jsonResponse = await LibraryApiCall.makeApiCall(
                            "checkAccessionNumber",
                            requestData,
                            "/api/library/instructor.php"
                        );

                        if (jsonResponse.success) {
                            let apiResult = jsonResponse.APIResult;
                            if (apiResult["status"] == "fail") {
                                this.setState({ accessError: "Accession number is already assigned to other resource.Kindly change accession number." })
                            }
                            else {
                                this.setState({ accessError: "Accession number from " + AccessionNumberArray[0] + " to " + (AccessionNumberArray[AccessionNumberArray.length - 1]) })
                            }
                        }
                    }
                    else {
                        this.setState({ accessError: "Invalid accession number.", AccessionNumber: '' })
                    }
                }
            }
            else {
                this.setState({ accessError: "Kindly select accession series.", copiesAccessionNumber: '' })
            }
        } else {
            this.setState({ accessError: "Kindly enter accession number." })
        }
    }

    // Add Copies Button on change
    AddResourceCopiesData = async () => {
        let validData = true;

        if (!this.state.copiesAccessionSeries) {
            this.setState({
                accessionSeriesWarning: 'Please select accession series.'
            });
            validData = false;
        }

        if (!this.state.copiesAccessionNumber) {
            this.setState({
                accessionNumberWarning: 'Please enter accession number.'
            });
            validData = false;
        }

        if (validData) {
            let requestData = {
                'iid': this.props.ResourceData.resourceIID, // config.institute_id,
                'accessionnumber': this.state.copiesAccessionNumber,
                'facultyId': config.faculty_id,
                'resourceid': this.props.ResourceData.uniqueId,
                'serireId': this.state.copiesAccessionSeries.uniqueId,
                'no_of_copies': this.state.copiesNoOfCopies
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'AddLibraryResourceCopies',
                requestData,
                '/api/library/instructor.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.AddResourceCopiesData();
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    this.setState({ isAddResourceCopies: false })
                    let apiResult = jsonResponse.APIResult;
                    if (apiResult.status == "success") {
                        toast.success(apiResult.message, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        this.closeResourceCopiesModal()
                    } else {
                        toast.warn(apiResult.message, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                } else {
                    this.setState({ isAddResourceCopies: false })
                    toast.error('Something went wrong while updating resources data. Please try again later.', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            }
        }
    }

    addResourceCopies = () => {
        return (
            <div className={this.state.isAddResourceCopies ? "modal fade show" : "modal fade"} id="modalContainer">
                <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50VW' }}>
                    <div className="modal-content modalBulkContent">
                        {/* Modal Header */}
                        <div className="modal-header" style={{ padding: '20px 25px', backgroundColor: '#0465ac', color: ' #ffffff' }}>
                            <h6 className="modal-title">
                                Add Copies
                            </h6>
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => { this.setState({ isAddResourceCopies: false }) }} style={{ cursor: "pointer" }} />
                        </div>

                        <div class="modal-body" style={{ padding: '20px 25px', maxHeight: "60vh", height: '75vh', overflowY: 'auto' }}>
                            <div className='col-md-12 pl-4 pt-2 pb-3'>
                                <div className='d-flex pb-3'>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Accession Series <span className='text-danger'>*</span></label>
                                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                            <Select
                                                options={this.props.accessionSeriesListData}
                                                value={this.state.copiesAccessionSeries}
                                                className="basic-multi-select-filter"
                                                onChange={(event) => {
                                                    this.setState({
                                                        copiesAccessionSeries: event || '', // Handle empty selection
                                                        copiesAccessionNumber: '',
                                                        accessionSeriesWarning: ''
                                                    }, () => this.GetMaximumLibraryAccession()
                                                    );
                                                }}
                                                placeholder="Select Accession Series"
                                                isClearable
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        width: '100%',
                                                        minHeight: 42, // Minimum height for the control area
                                                        height: 'auto', // Allow control to grow dynamically
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999, // Ensure the dropdown appears above other elements
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                        color: state.isSelected ? '#333' : '#555',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: '400',
                                                    }),
                                                }}
                                                menuPortalTarget={document.body}
                                                required
                                            />
                                            <p style={{ display: this.state.accessionSeriesWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.accessionSeriesWarning}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Accession Number <span className='text-danger'>*</span></label>
                                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                            <input
                                                type="text"
                                                className="form-control formControlAutoTask"
                                                placeholder="Enter Accession Number"
                                                style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                                value={this.state.copiesAccessionNumber} // Bind value to state
                                                onChange={(e) => {
                                                    this.setState({
                                                        copiesAccessionNumber: e.target.value || '',
                                                        accessionNumberWarning: ''
                                                    }, () => {
                                                        this.checkAccessionNumber(this.state.copiesAccessionNumber)
                                                    })
                                                }}
                                                maxLength={20}
                                                required
                                            />
                                            <p style={{ display: this.state.accessionNumberWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.accessionNumberWarning}</p>
                                        </div>
                                        <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 20 characters are allowed)</p>
                                    </div>
                                    <div className='col-md-4 pl-0'>
                                        <label className='fs-14 fieldHeadColor '>Number of Copies</label>
                                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                            <input
                                                type="number"
                                                className="form-control formControlAutoTask"
                                                placeholder="Enter Number of Copies"
                                                style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                                value={this.state.copiesNoOfCopies} // Bind value to state
                                                onChange={(e) => {
                                                    const input = e.target.value;

                                                    // Allow only digits
                                                    if (/^\d*$/.test(input)) {
                                                        const numericValue = Number(input);

                                                        // Allow only values from 1 to 50000
                                                        if ((numericValue >= 1 && numericValue <= 50000) || input === '') {
                                                            this.setState({ copiesNoOfCopies: input }, () => {
                                                                this.checkAccessionNumber(this.state.copiesNoOfCopies);
                                                            });
                                                        }
                                                    }
                                                }}
                                                min={1}
                                                max={50000}
                                            />
                                        </div>
                                        <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 50000 copies are allowed)</p>
                                    </div>
                                </div>
                            </div>
                            <p className='fs-14 fieldHeadColor'>{this.state.accessError}</p>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer" style={{ padding: '20px 25px' }}>
                            <button
                                className="btn btn-outline-primary"
                                style={{ fontSize: '14px', borderRadius: '7px' }}
                                onClick={() => { this.setState({ isAddResourceCopies: false }) }}
                            >
                                Cancel
                            </button>
                            <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }}
                                onClick={() => { this.AddResourceCopiesData() }}
                            >
                                Add Copies
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // Print Barcode Modal
    printBarcodeData = () => {
        const selectedItems = Array.isArray(this.state.selectedRow) ? this.state.selectedRow : [this.state.selectedRow];

        const copies = this.state.printBarcodeType === "Print Barcode 2 Copies" ? 2 :
            this.state.printBarcodeType === "Print Barcode 3 Copies" ? 3 :
                this.state.printBarcodeType === "Print Barcode 4 Copies" ? 4 : 1;

        // Flatten all barcodes into a single array
        const allBarcodes = selectedItems.flatMap(row =>
            Array.from({ length: copies }).map(() => row)
        );

        // Chunk barcodes into rows of 4
        const chunkedRows = [];
        for (let i = 0; i < allBarcodes.length; i += 4) {
            chunkedRows.push(allBarcodes.slice(i, i + 4));
        }

        return (
            <div className={this.state.printBarcodeModal ? "modal fade show" : "modal fade"} id="modalContainer">
                <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50VW' }}>
                    <div className="modal-content modalBulkContent">
                        {/* Modal Header */}
                        <div className="modal-header" style={{ padding: '20px 25px', backgroundColor: '#0465ac', color: ' #ffffff' }}>
                            <h6 className="modal-title">
                                Print Barcode
                            </h6>
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => { this.setState({ printBarcodeModal: false, printBarcodeType: '' }) }} style={{ cursor: "pointer" }} />
                        </div>

                        <div class="modal-body" style={{ padding: '20px 25px', maxHeight: "60vh", height: '75vh', overflowY: 'auto' }}>
                            <div className="d-flex justify-content-end">
                                <ReactToPrint
                                    trigger={() => {
                                        return (
                                            <button className="btn btn-outline-primary" >
                                                <FontAwesomeIcon size='sm' icon={["fa", "print"]} /> &nbsp;Print
                                            </button>
                                        );
                                    }}
                                    content={() => this.printReference}
                                />
                            </div>

                            <div ref={el => this.printReference = el}>
                                <table className="table table-bordered mt-4" style={{ width: '100%', tableLayout: 'fixed' }}>
                                    <tbody>
                                        {chunkedRows.map((rowGroup, rowIndex) => (
                                            <tr key={rowIndex}>
                                                {rowGroup.map((row, idx) => (
                                                    <td
                                                        key={idx}
                                                        style={{
                                                            border: '1px solid #ccc',
                                                            textAlign: 'center',
                                                            verticalAlign: 'middle',
                                                            padding: '10px',
                                                            width: `${100 / 4}%`  // If you're doing 3 per row
                                                        }}
                                                    >
                                                        <Barcode
                                                            value={row.accessionnumber}
                                                            displayValue={true}
                                                            height={40}
                                                            width={1}
                                                        />
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    render() {

        const { resourceCopiesModal, ResourceData } = this.props;

        return (
            <div className={resourceCopiesModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50VW' }}>
                    <div class="modal-content">
                        {/* modal header data */}
                        <div class="modal-header" style={{ padding: '15px' }}>
                            <h6 class="modal-title text-white" style={{ fontWeight: 500, color: "#000000" }}>Add Copies to - {ResourceData.title}</h6>
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => this.closeResourceCopiesModal()} style={{ cursor: "pointer" }} />
                        </div>

                        {/* modal content */}
                        <div class="modal-body" style={{ maxHeight: "60vh", height: '75vh', overflowY: 'auto' }}>
                            <div className="d-flex justify-content-end">
                                {/* Action Button */}
                                <div style={{ position: 'relative' }}>
                                    <button className="btn btn-primary" id='actionDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" disabled={this.state.selectedRows.length === 0}>
                                        Action <FontAwesomeIcon size='lg' icon={["fa", "sort-down"]} style={{ cursor: "pointer" }} />
                                    </button>
                                    <div className="dropdown-menu  vm-dropdown-menu" aria-labelledby='actionDropdownMenu' style={{
                                        maxHeight: '250px',  // Set your desired height
                                        overflowY: 'auto',
                                        boxShadow: '4px 4px 10px #b7adad'
                                    }}>
                                        {
                                            this.state.itemVisibilityForRows.map((columnInfo, index) => {
                                                return (
                                                    <p className="dropdown-item"
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center', // Vertical center alignment
                                                            fontSize: '14px',
                                                            cursor: 'pointer',
                                                            padding: '8px 10px',
                                                            marginBottom: '3px',
                                                            gap: '6px'
                                                        }}
                                                        key={columnInfo.name}
                                                        onClick={() => this.actionButtonOnChange(columnInfo.name)}
                                                    >
                                                        <FontAwesomeIcon size='lg' icon={columnInfo.icon} style={{ cursor: "pointer" }} />
                                                        <span>{columnInfo.name}</span>
                                                    </p>
                                                );
                                            })
                                        }
                                    </div>
                                </div>

                                <button className="btn btn-outline-primary" onClick={() => this.setState({ isAddResourceCopies: true })} >
                                    <FontAwesomeIcon size='sm' icon={["fa", "plus"]} /> &nbsp;Add Copies
                                </button>
                            </div>

                            <div className="table-responsive fixTableHead table_pad mt-2" id='tableResponsive'>
                                <div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="resourceList">
                                        <thead>
                                            <tr>
                                                <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>
                                                    <input
                                                        type='checkbox'
                                                        onChange={this.handleSelectAllCheckboxChange}
                                                        checked={
                                                            this.state.selectedRows.length === Object.values(this.state.resourceResponseData).length &&
                                                            Object.values(this.state.resourceResponseData).length > 0
                                                        }
                                                        style={{ marginRight: 5 }}
                                                    />
                                                </th>
                                                <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Sr. No.</th>
                                                <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Accession Series text</th>
                                                <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Accession Number</th>
                                                <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Last Modified By</th>
                                                <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.loadingResourceData ? <tr>
                                                    <td colSpan="4">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                    Object.keys(this.state.resourceResponseData).length > 0 ?
                                                        (Object.values(this.state.resourceResponseData).map((resource, index) => (
                                                            <tr key={index}>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>
                                                                    <input type='checkbox'
                                                                        onChange={() => this.handleCheckboxChange(resource.uniqueId)}
                                                                        checked={this.state.selectedRows.includes(resource.uniqueId)}
                                                                    />
                                                                </td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{index + 1}</td>
                                                                {this.state.isUpdateAccessionSeries === true && this.state.currentAccessionSeriesNo === index ?
                                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>
                                                                        <div className="input-group input-group-field" style={{ position: 'relative', display: "flex", direction: 'row', alignItems: 'center', gap: '5px' }}>
                                                                            <Select
                                                                                options={this.props.accessionSeriesListData}
                                                                                onChange={(event) => {
                                                                                    this.setState({
                                                                                        accessionSeriesText: event || ''
                                                                                    })
                                                                                }}
                                                                                isSearchable
                                                                                isClearable
                                                                                value={this.state.accessionSeriesText}
                                                                                placeholder="Select Accession Series"
                                                                                styles={{
                                                                                    control: (base) => ({
                                                                                        ...base,
                                                                                        minHeight: 42, // Minimum height for the control area
                                                                                        height: 'auto', // Allow control to grow dynamically,
                                                                                        fontSize: "13px",
                                                                                        fontWeight: 400,
                                                                                    }),
                                                                                    option: (base, state) => ({
                                                                                        ...base,
                                                                                        fontSize: "13px",
                                                                                        fontWeight: 400,
                                                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                                        color: state.isSelected ? '#333' : '#555',
                                                                                    }),
                                                                                    menu: (base) => ({
                                                                                        ...base,
                                                                                        zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                                        // maxHeight: '200px', // Limit the height of the dropdown
                                                                                        overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                                                        position: 'absolute', // Fix the position to avoid getting cut off
                                                                                    }),
                                                                                    menuPortal: (base) => ({
                                                                                        ...base,
                                                                                        zIndex: 9999, // Ensure the menu is above other modal content
                                                                                    }),
                                                                                    placeholder: (base) => ({
                                                                                        ...base,
                                                                                        fontSize: '14px',
                                                                                        fontWeight: '400', // Use fontWeight for normal text

                                                                                    }),
                                                                                }}
                                                                                menuPortalTarget={document.body}
                                                                            />
                                                                        </div>
                                                                    </td> :
                                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }} title={resource.AccessionText}>{resource.AccessionText.length > 20 ? resource.AccessionText.slice(0, 20) + '...' : resource.AccessionText}</td>
                                                                }
                                                                {this.state.isUpdateAccessionSeries === true && this.state.currentAccessionSeriesNo === index ?
                                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>
                                                                        <div className="input-group input-group-field" style={{ position: 'relative', display: "flex", direction: 'row', alignItems: 'center', gap: '5px' }}>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control formControlAutoTask"
                                                                                placeholder="Enter Accession Series Text"
                                                                                style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: 'auto', fontSize: "13px" }}
                                                                                value={this.state.accessionNumberText} // Bind value to state
                                                                                onChange={(event) => {
                                                                                    this.setState({
                                                                                        accessionNumberText: event.target.value || '', // Handle empty selection
                                                                                    });
                                                                                }}
                                                                            />

                                                                        </div>

                                                                    </td> :
                                                                    <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }} title={resource.accessionnumber}>{resource.accessionnumber.length > 20 ? resource.accessionnumber.slice(0, 20) + '...' : resource.accessionnumber}</td>
                                                                }
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF', cursor: "pointer", color: resource.uniqueId == this.state.hoverID ? "#0465AC" : "" }}
                                                                    onMouseEnter={() => this.setState({ hoverID: resource.uniqueId })}
                                                                    onMouseLeave={() => this.setState({ hoverID: "" })}
                                                                    onClick={() => this.openActivitySlider(resource.uniqueId)}>
                                                                    {resource.updated_by_Name ? (
                                                                        <div className="d-flex flex-column">
                                                                            <div>{resource.updated_by_Name} ({resource.last_updated_by_ERP}) | {resource.updatedOn}</div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="d-flex flex-column">
                                                                            <div>{resource.added_by_name} ({resource.added_by_ERP}) | {resource.addedOn}</div>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF', padding: '1.5rem' }}>
                                                                    {this.state.isUpdateAccessionSeries == true && this.state.currentAccessionSeriesNo === index ?
                                                                        <>
                                                                            <FontAwesomeIcon icon={['fas', 'check']} size="lg" style={{ cursor: "pointer", marginRight: 5, color: 'green' }}
                                                                                onClick={() => {
                                                                                    this.UpdateLibraryResourceCopies()
                                                                                }}
                                                                            />
                                                                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" style={{ cursor: "pointer", color: 'red' }} onClick={() => {
                                                                                this.setState({ isUpdateAccessionSeries: false, accessionSeriesText: '', accessionNumberText: '', currentAccessionSeriesNo: null })
                                                                            }} />
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <FontAwesomeIcon icon={['far', 'edit']} size="lg" title="Click to edit the accession number" style={{ cursor: "pointer", marginRight: 5 }}
                                                                                onClick={() => {
                                                                                    this.setState({ isUpdateAccessionSeries: true, accessionSeriesText: this.props.accessionSeriesListData.filter(item => item.label === resource.AccessionText), accessionNumberText: resource.accessionnumber, selectedRow: resource, currentAccessionSeriesNo: index })
                                                                                }}
                                                                            />
                                                                            <FontAwesomeIcon icon={['far', 'trash-alt']} size="lg" title="Click to delete the accession number" style={{ cursor: "pointer", marginRight: 5 }}
                                                                                onClick={() => {
                                                                                    this.setState({ isDeleteAccessionSeries: true, selectedRow: resource, deleteType: 'deleteRow' })
                                                                                }}
                                                                            />
                                                                        </>
                                                                    }

                                                                </td>
                                                            </tr>
                                                        ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3">No data found.</td>
                                                            </tr>
                                                        )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.deleteAccessionSeriesData()
                }
                {
                    this.addResourceCopies()
                }
                {
                    this.printBarcodeData()
                }
                {
                    this.state.showActivitySlider && this.state.selectedIid != "" &&
                    <SpecificUserLog
                        showSlider={this.state.showActivitySlider}
                        closeSlider={this.closeActivitySlider}
                        logUid={this.state.selectedIid}
                        activityArr={["resourceCopy_added", "resourceCopy_updated", "copies_deleted"]}
                    />
                }
            </div>
        );
    }
}

export default AddResourceCopies;